exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".independent-scroll{max-height:100vh;overflow-y:scroll;padding-bottom:10px}", ""]);

// exports
